import {Fragment, PureComponent} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {Card, CardBody, CardText, CardTitle} from 'reactstrap'

import GetMissions from '../../../components/GetMissions/GetMissions.jsx'
import HowToGetMissions from '../../../components/HowToGetMissions/HowToGetMissions.jsx'
import Header from '../../../components/Header/Header.jsx'
import Landing from '../Landing.jsx'
import LinkAs from '../../../components/LinkAs/LinkAs.jsx'
import Partnerships from '../../../components/Partnerships/Partnerships.jsx'

import {generate} from '../../../routes.js'
import {isUserFreelance} from '../../../../shared/services/userService.js'

import header from './images/header-generic-hr.png?size=600'

import './LandingFreelance.scss'

const universes = [
  {name: 'Achats', code: 'purchase', keywords: ['Acheteur international', 'Responsable Achat', 'Responsable approvisionnement', 'Acheteur IT', 'Acheteur public', 'Approvisionneur', 'Contract Manager...']},
  {name: 'Finance', code: 'finance', keywords: ['DAF / RAF', 'Trésorier', 'Contrôleur de gestion', 'Consolideur', 'Analyste financier', 'FP&A', 'Responsable comptabilité...']},
  {name: 'Ingénierie technique', code: 'engineering', keywords: ['Ingénieur mécanique', 'Ingénieur qualité', 'Ingénieur process', 'Ingénieur électronique', 'Ingénieur logistique...']},
  {name: 'Ressources Humaines', code: 'hr', keywords: ['DRH / RRH', 'Responsable paie', 'Responsable relations sociales', 'SIRH', 'Responsable formation...']},
]

const title = "Twineeds | Missions consultants Ingénierie, Achats, Finance"
const description = "Consultants indépendants et freelances : boostez votre carrière grâce à des missions adaptées à vos compétences. Rencontrez nos équipes et recevez votre offre."

class LandingFreelance extends PureComponent {
  render() {
    const headerBrief = <p>Twineeds vous met en relation avec <strong>des entreprises</strong>. Ingénierie, Achats, Supply, Finance ou RH : rencontrez-nous pour parler de votre projet, <strong>nous identifions la mission</strong> qui vous correspond.</p>

    const headerCtas = <Fragment>
      <LinkAs
        className="btn btn-primary"
        notConnected={generate({name: 'register-freelance'})}
        freelance={generate({name: 'offers'})}
      >
        {isUserFreelance ? 'Consulter les missions' : 'Nous rencontrer'}
      </LinkAs>
    </Fragment>

    return <Landing
      className="landing-freelance"
      helmet={{title, description}}
    >
      <Header
        brief={headerBrief}
        ctas={headerCtas}
        imageAlt={'PC et portable montrant un site d\'intermédiation pour consultants freelances et entreprise'}
        imageSrc={header.src}
        title="Consultant indépendant ? Boostez votre carrière et trouvez vos missions partout en France"
      />

      <div className="bg-light">
        <section id="universes" className="container text-center py-5">
          <h2 className="mb-4">Les métiers adressés</h2>
          <ul className="row card-deck pl-0 mb-0">
            {universes.map((universe) => (
              <li className="d-flex flex-column align-items-center col-xs-12 col-md-3 mb-3 mb-md-0" key={universe.code}>
                <Card className="mb-2 w-100">
                  <CardBody>
                    <CardTitle tag="h3">{universe.name}</CardTitle>
                    <CardText className="pl-0" tag="ul">
                      {universe.keywords.map((keyword, index) => <li key={index}>{keyword}</li>)}
                    </CardText>
                  </CardBody>
                </Card>
                <Link className="btn btn-primary mt-3" to={generate({name: 'landing-freelance-' + universe.code})}>
                  En savoir plus
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <HowToGetMissions/>
      <GetMissions/>
      <Partnerships/>
    </Landing>
  }
}

export default connect(
  state => ({
    isUserFreelance: isUserFreelance(state.currentUser.user)
  })
)(LandingFreelance)
